import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * Caixa / item padrão dual-theme para Configurações.
 *
 * Light: branco elevado sobre o painel #F8FAFC
 * Dark: #27272A elevado sobre o painel #18181B
 */
export function SettingsCard({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="settings-card"
      className={cn(
        "overflow-hidden rounded-xl border border-[#E5E7EB] bg-white shadow-sm transition-colors duration-200 dark:border-[#3F3F464D] dark:bg-[#27272A] dark:shadow-none",
        className
      )}
      {...props}
    />
  );
}

export default SettingsCard;
